export function getRandomInt(max) {
    return 1 + Math.floor(Math.random() * Math.floor(max));
}
